module.exports = __webpack_public_path__ + "img/f3-1-l.09bd4620.png";